import styled from "styled-components";

const FormWrapper = styled.div`
  display: ${props => (props.open ? "block" : "none")};
`;

export default FormWrapper;
